/* tslint:disable */

/**
 */
export class ViewBrainOptim {
    idStudy?: number;
    idStudyEquipment?: number;
    BRAIN_OPTIM?: number;
    EQUIP_STANDARD?: number;
    BRAIN_OPTIM_TSFIXED?: number;
    BRAIN_OPTIM_TRFIXED?: number;
    BRAIN_OPTIM_DHPFIXED?: number;
    BRAIN_OPTIM_TOPFIXED?: number;
    BRAIN_OPTIM_COSTFIXED?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-brain-optim.ts